import { TelegramLogoIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Telegram = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <TelegramLogoIcon size={Sizes[size]} fill={stroke || fill} {...rest} />;
};

Telegram.displayName = 'Telegram';
